
import { tables } from '@/lib/supabase';
import { handleError, ErrorSeverity, ErrorContext } from '@/utils/errorHandler';
import { StaffMember } from '@/types/staffTypes';

export const getStaffMembers = async (): Promise<StaffMember[]> => {
  try {
    const { data, error } = await tables.staff_members()
      .select('*')
      .order('first_name', { ascending: true });

    if (error) throw error;

    return data as StaffMember[];
  } catch (error) {
    handleError(
      error,
      "Failed to fetch staff members",
      ErrorSeverity.ERROR,
      { operation: 'getStaffMembers' }
    );
    return [];
  }
};

export const getStaffMemberById = async (id: string): Promise<StaffMember | null> => {
  try {
    const { data, error } = await tables.staff_members()
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      const context: ErrorContext = {
        operation: 'getStaffMemberById',
        additionalInfo: { id }
      };
      handleError(error, "Failed to fetch staff member", ErrorSeverity.ERROR, context);
      return null;
    }

    return data as StaffMember;
  } catch (error) {
    const context: ErrorContext = {
      operation: 'getStaffMemberById',
      additionalInfo: { id }
    };
    handleError(error, "Failed to fetch staff member", ErrorSeverity.ERROR, context);
    return null;
  }
};

